const STORAGE_KEY = "__volumental_auth_token";

const getStoredToken = (): string | undefined => {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
};

const setStoredToken = (token: string | undefined): void => {
  try {
    if (token) {
      localStorage.setItem(STORAGE_KEY, token);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // localStorage may not be available in some contexts
  }
};

let authToken: string | undefined = getStoredToken();

export const tokenStore = {
  getToken: () => authToken,
  setToken: (token: string | undefined) => {
    authToken = token;
    setStoredToken(token);
  },
  clearToken: () => {
    authToken = undefined;
    setStoredToken(undefined);
  },
};
